import { render, staticRenderFns } from "./CreateLevel.vue?vue&type=template&id=3c05e62f&lang=pug&"
import script from "./CreateLevel.vue?vue&type=script&lang=ts&"
export * from "./CreateLevel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports